/**
 * A group's visibility is stored as two booleans on the record: `isPublic` and
 * `isGlobal` (neither set = private).
 *
 * Group Type (dashboard / report) is no longer captured when creating a group, so
 * the Groups list shows visibility in its Type column instead. This is the single
 * place that mapping lives, so the list, the grid cards and the filter agree.
 */

export const GROUP_VISIBILITIES = ["private", "public", "global"];

export const getGroupVisibility = (group) => {
  if (group?.isGlobal) return "global";
  if (group?.isPublic) return "public";
  return "private";
};

export const getGroupVisibilityLabel = (group) => {
  const visibility = getGroupVisibility(group);
  return visibility.charAt(0).toUpperCase() + visibility.slice(1);
};

/**
 * Global groups are a super-user concept — only they can create one, so only they
 * are offered it as a filter.
 */
export const isSpecialUser = () => localStorage.getItem("IsSpecialUser") === "true";
